import { adminTypes } from "@admin/admin-types.di";
import type { AdminRepository } from "@admin/domain/repositories/admin.repository";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type { Nullable } from "@core/domain/types/nullable.type";
import { RecuperableModelError } from "@iot-platform/core";
import type { SpatialLevelResume } from "@station/domain/models/spatial-level-resume.model";
import { inject, injectable } from "inversify";

@injectable()
export class SpatialLevelAddUserUseCase {
    constructor(
        @inject(adminTypes.repositories.AdminRepository)
        private readonly adminRepository: AdminRepository,
    ) {}

    async execute(
        stationId: string,
        spatialLevelId: string,
        userIds: number[],
    ): Promise<Nullable<SpatialLevelResume>> {
        const addUserResult = await this.adminRepository.addUserToSpatialLevel(
            stationId,
            spatialLevelId,
            userIds,
        );

        return addUserResult.match(
            (spatialLevelUserAdded) => spatialLevelUserAdded,
            (error) => {
                if (error instanceof RecuperableModelError) {
                    ToastManagerRepository.warning(error.message);

                    return error.instance;
                }

                ToastManagerRepository.error(error.message);

                return null;
            },
        );
    }
}
